module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQoNCiA8Zz4NCiAgPHRpdGxlPmJhY2tncm91bmQ8L3RpdGxlPg0KICA8cmVjdCBmaWxsPSJub25lIiBpZD0iY2FudmFzX2JhY2tncm91bmQiIGhlaWdodD0iNDAyIiB3aWR0aD0iNTgyIiB5PSItMSIgeD0iLTEiLz4NCiA8L2c+DQogPGc+DQogIDx0aXRsZT5MYXllciAxPC90aXRsZT4NCiAgPHBhdGggdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAxMiw5KSAiIGlkPSJzdmdfMSIgZD0ibTcuNSwxLjVsLTYsNy41bDYsNy41bS02LC03LjVsMjEsMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZT0iIzAwMCIgZmlsbD0ibm9uZSIvPg0KIDwvZz4NCjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./images/black-arow-left.svg
// module id = 165
// module chunks = 0